import { graphql } from '@gql';

export const GET_COMPONENT_CREATE_REQUESTS_PAGED = graphql(`
    query GetComponentCreateRequestsPaged(
        $first: Int
        $last: Int
        $after: Cursor
        $before: Cursor
        $where: ComponentCreateRequestWhereInput
        $orderBy: ComponentCreateRequestOrder
    ) {
        componentCreateRequestsView(
            first: $first
            last: $last
            after: $after
            before: $before
            where: $where
            orderBy: $orderBy
        ) {
            totalCount
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                cursor
                node {
                    id
                    componentID
                    componentName
                    componentVersion
                    componentVendorName
                    componentVendorID
                    requestPriority
                    userID
                    requesterID
                    referenceWeb
                    referenceSecurity
                    statusID
                    statusCode
                    sourceID
                    externalRequestRef
                    externalComponentID
                    externalRequestStatus
                    statusTransitions {
                        id
                        code
                        blocked
                        reason
                    }
                    comments {
                        comment
                        userID
                        createTime
                    }
                }
            }
        }
    }
`);
